import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShieldAlt,
  FaRocket,
  FaSyncAlt,
  FaChartLine,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EcommerceWebsiteMaintenanceInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-commerce Website Maintenance in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Keep Your Store Thriving</Subheading>}
        heading={
          <Heading>
            E-commerce Website <span tw="text-primary-500">Maintenance</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert e-commerce website maintenance
            services in **Bur Dubai**, ensuring your online store stays secure,
            fast, and fully functional. Let us handle the upkeep so you can
            focus on growing your business.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce maintenance dashboard
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Website maintenance team
          "https://images.unsplash.com/photo-1600267204091-5c1ab8b10c02?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Online store success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Maintain Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Reliable E-commerce Maintenance in Bur Dubai"
        description="We keep your online store running at its best with comprehensive support."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Regular Updates",
            description: "Keep software, plugins, and features current.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Security Monitoring",
            description: "Protect against threats with proactive measures.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Performance Tuning",
            description: "Optimize speed and uptime for better UX.",
          },
          {
            icon: <FaSyncAlt color="#ff5464" size={40} />,
            title: "Bug Fixes",
            description: "Quickly resolve issues to maintain functionality.",
          },
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Analytics Support",
            description: "Track performance and improve sales strategies.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Service",
            description: "Dependable maintenance for Bur Dubai businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Maintenance Process"
        description={
          <Description>
            We ensure your e-commerce site stays in top shape with a structured
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Assessment: Evaluate your site’s current state.</li>
              <li>Updates: Apply patches, upgrades, and optimizations.</li>
              <li>Security: Monitor and enhance protection measures.</li>
              <li>
                Testing: Verify functionality and performance post-changes.
              </li>
              <li>Backup: Regular backups to prevent data loss.</li>
              <li>Support: Ongoing assistance for seamless operation.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce maintenance tools
          "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Website monitoring
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Testing and optimization
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Maintenance Success in Bur Dubai"
        description="Our maintenance services have kept local stores thriving."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Uptime Boost",
            description: "Achieved 99.9% uptime for a busy retailer.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Threat Prevention",
            description: "Blocked 100+ security threats in a year.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction from maintenance clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Stay Online?</Subheading>}
        heading="E-commerce Maintenance in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert e-commerce website
            maintenance in Bur Dubai. Keep your store secure, fast, and
            reliable—contact us today to ensure uninterrupted success!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Maintenance team collaboration
          "https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce website analytics
          "https://images.unsplash.com/photo-1534224039826-c7a0fb1c5c1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai skyline for local context
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
